import React, { useState, useEffect } from 'react';
import '../HomeScreen/style.css';

const AboutUs = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleImageClick = (e) => {
    e.stopPropagation();
    setModalOpen(true);
  };

  return (
    <>
      {/* Page Header for SEO and Google Ads Compliance */}
      <header className="page-header" style={{
        background: 'linear-gradient(135deg, #561314 0%, #8B0000 100%)',
        color: 'white',
        textAlign: 'center',
        padding: '2rem 1rem',
        marginBottom: '0'
      }}>
        <h1 style={{
          fontSize: '2.5rem',
          margin: '0 0 1rem 0',
          fontWeight: '600',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}>
          About Rameshwaram Villa - Luxury Accommodation in Pathankot
        </h1>
        <p style={{
          fontSize: '1.2rem',
          margin: '0',
          maxWidth: '800px',
          marginLeft: 'auto',
          marginRight: 'auto',
          lineHeight: '1.6',
          opacity: '0.95'
        }}>
          Discover our premium 6BHK villa featuring indoor swimming pool, personal movie theatre, and world-class amenities. 
          Located strategically near major tourist destinations including Dalhousie, Dharamshala, and sacred Shaktipeeth sites.
        </p>
      </header>
      
      <section className="about-section">
      {isMobile && (
        <img
          src="/aboutSection.jpeg"
          alt="About Rameshwaram Villa"
          style={{ width: '100%', height: '90vh', objectFit: 'contain', borderRadius: 18, margin: '0 auto 16px auto', display: 'block', cursor: 'pointer', background: '#eaf3fa' }}
          onClick={handleImageClick}
        />
      )}
    <div className="about-content" style={{position:'relative', zIndex:2}}>
      <div className="about_taital">About Us</div>
      <p className="about_text">Rameshwaram Villa is a 6bhk Property which is the ideal hill side escape anyone may have been dreaming off. Whether you are looking for a party place or you may need a luxurious place to spend time with your family Rameshwaram Villa is best for both.</p>
      <p className="about_text">Facilities will include fully functional modular kitchen Luxurious rooms, Swimming pool, Bar & a Personal Movie Theatre with 6 Full Recliners Sofa.</p>
      <p className="about_text"><strong>About this place:-</strong></p>
      <p className="about_text">From large family gatherings, shadi parties, cocktails parties, pool parties we welcome all. Our home stay greets each guest with gratitude! At a distance of 75km from Dalhousie, 86 KM from Dharamshala,Centre location from 3 Shaktipeeth Chintpurni, Jwaladevi, Shri Tripurmalini. Less than 5km from Himachal mountains. Mata Vaishnodevi is also 150 KM away from this location.</p>
      <p className="about_text">There are lot of tourists attractions in Pathankot like Mini Goa, Pandava Mandir, Oldest Shani Dev mandir, Damn Area.</p>
      <p className="about_text">Rameshwaram Villa is coziest yet luxurious property of entire Pathankot. It has a first and only indoor swimming pool, personal movie theatre & Open bonfire.</p>
      <p className="about_text">As you walk inside this luxurious property you'll be welcomed by an indoor swimming pool and in upper ground and first floor all rooms & hall giving it a luxurious and homely feel.</p>
      <p className="about_text">In upper ground and in first floor there is a dining table for 6 people sofa for 8 people and In the middle of the living room, you'll find one of the favorite spot, wherein we have META SHOT trough which you may play a online cricket. We also have a personal swimming pool and personal movie theatre with recliner seats.</p>
      <p className="about_text">You can read, draw, play, or just enjoy the mesmerising views. This Villa also has a TV with Netflix, Amazon Prime and Hotstar accounts available for your entertainment.</p>
      <p className="about_text"><strong>Important Policy:</strong></p>
      <p className="about_text">Rameshwaram Villa is situated in Victoria Estate, one of the most prestigious locations in Pathankot. We have a strict zero-tolerance policy towards narcotics, drugs, gambling, prostitution, mujra, or any other illegal activities. Guests will be solely responsible for any consequences arising from such activities if found on our property.</p>
    </div>
      {!isMobile && (
        <div className="about-image-container">
          <img
            src="/aboutSection.jpeg"
            alt="About Rameshwaram Villa"
            className="about-image"
            onClick={handleImageClick}
            style={{ cursor: 'pointer' }}
          />
        </div>
      )}
  </section>
    </>
  );
};

export default AboutUs;